import { waitFor } from "@kluntje/js-utils/lib/dom-helpers";

import DebuggerService from "./DebuggerService";

class DataLayerService {
  init() {
    window.gtag = function () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
  }

  push(...data: any[]) {
    const dataLayer = window.dataLayer;
    if (dataLayer === undefined) {
      DebuggerService.warn("DataLayerService: Cannot push to DataLayer, DataLayer is not defined");
      this.pushLater(3, ...data);
      return;
    }

    DebuggerService.log("DataLayerService push:", ...data);
    dataLayer.push(...data);
  }

  private async pushLater(attempts: number, ...data: any[]) {
    if (attempts <= 0) return;
    DebuggerService.warn(`DataLayerService: Try pushLater to DataLayer, ${attempts} attempts left`);
    await waitFor(1500);
    if (window.dataLayer !== undefined) {
      DebuggerService.log("DataLayerService push:", ...data);
      window.dataLayer.push(...data);
      return;
    }
    DebuggerService.warn("DataLayerService: Cannot push to DataLayer, DataLayer is not defined");
    await this.pushLater(attempts - 1, ...data);
  }
}

export default new DataLayerService();
